//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { toLoadComponents, wapMenuList } from '~/static/json/allMenu.json'
import vpsBanner from '~/components/home/banner.vue'
import sentimentPosi from '~/components/home/sentimentAndPosi.vue'
import historicalRatio from '~/components/home/historicalLongRatio.vue'
import wapTabs from '~/components/common/tabs.vue'
import adsense from '~/components/home/adsense.vue'
import { matomofn, add, subtract, hasIn, toSpecifyLocation, menuLight, langFn } from '~/assets/js/utils.js'

export default {
  components: {
    'vps-banner': vpsBanner,
    'sentiment-posi': sentimentPosi,
    'historical-ratio': historicalRatio,
    'trading-environment': () => import('~/components/home/tradingEnvironment.vue'/* webpackChunkName: 'tradingEnvironment' */),
    'blowout-data': () => import('~/components/home/blowoutData.vue'/* webpackChunkName: 'blowoutData' */),
    'burst-distribution': () => import('~/components/home/burstDistribution.vue'/* webpackChunkName: 'burstDistribution' */),
    'ea-shop': () => import('~/components/home/eaShop.vue'/* webpackChunkName: 'eaShop' */),
    'wind-ranking': () => import('~/components/home/eaWindRanking.vue'/* webpackChunkName: 'windRanking' */),
    'trading-quotes': () => import('~/components/home/tradingQuotes.vue'/* webpackChunkName: 'tradingQuotes' */),
    'funds-flow': () => import('~/components/home/fundsFlow.vue'/* webpackChunkName: 'fundsFlow' */),
    'overnight-fee': () => import('~/components/home/overnightFee.vue'/* webpackChunkName: 'overnightFee' */),
    'deep-tracking': () => import('~/components/home/deepTracking.vue'/* webpackChunkName: 'deepTracking' */),
    'funds-trends': () => import('~/components/home/fundsTrends.vue'/* webpackChunkName: 'fundsTrends' */),
    'wap-tabs': wapTabs,
    adsense
  },
  async asyncData ({ store, $api }) {
    const { locale = 'en', countryCode = '' } = store.state
    const [bannerObj, emotionObj, posiObj, vpsObj, res] = await Promise.all([
      $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/vpsInfo' }).catch(() => {}),
      $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/longShortRate' }, { symbol: 'EURUSD', languageCode: langFn(locale) }).catch(() => {}),
      $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/holdposition' }, { symbol: 'EURUSD', languageCode: langFn(locale) }).catch(() => {}),
      $api.home.vpsInfo().catch(() => {}),
      $api.common.v3Server({ Routes: 'cloudvps$regionInfoForDealerPage,cloudvpsapi$vpsnuminfo,fxad$advertisementv2', BasicData: store.getters?.getDiffBasic }, { apiCountryCode: countryCode, brokerId: '0001378443', type: 1100 }).catch(() => {})
    ])
    const { promoteInfo = {}, priceInfo = {} } = res?.cloudvps?.regioninfofordealerpage?.data?.typeList?.[0] || {}
    const chineseTxt = promoteInfo?.text || '0.1 USD/month' // 当前选择的国家为中国时，使用该字段
    const foreignTxt = (priceInfo?.Amount || 0.1) + (priceInfo?.code || 'USD') + '/' + (priceInfo?.unit || 'month') // 反之，使用该字段
    const { user_list: uList = [], vps_online_num: onlineCount = 0 } = res?.cloudvpsapi?.vpsnuminfo?.data?.vpsinfo || {}
    const hasAd = res?.fxad?.advertisementv2?.data || []
    return {
      bannerObj,
      onlineNum: onlineCount || 0,
      lowestPrice: (countryCode != '156' ? foreignTxt : chineseTxt),
      moodList: emotionObj?.list || [],
      posiList: posiObj?.list || [],
      vpsList: (vpsObj || []),
      buyList: uList || [],
      adList: hasAd?.length ? hasAd?.slice(0, 1) : []
    }
  },
  data () {
    toLoadComponents?.forEach((item) => {
      item.isShow = false
      item.showGap = !hasIn(item, 'showGap')
    })
    wapMenuList?.forEach((item, index) => {
      item.code = String(add(index, 1))
      item.name = this.$t(item.name)
    })
    return {
      componentList: toLoadComponents, // 组件列表
      bannerObj: {}, // banner数据
      onlineNum: 0, // 在线人数
      lowestPrice: '0.1 USD/month', // 最低价格
      bannerHeight: 0, // banner模块的高度
      moodList: [], // 多空情绪列表
      posiList: [], // 持仓分布列表
      vpsList: [], // VPS版本列表
      buyList: [], // 实时购买人数
      wapMenuList, // 菜单导航栏（移动端）
      wapSelect: 1, // 菜单导航栏（移动端）选中项
      isFixed: false, // 菜单导航栏（移动端）是否固定在头部
      adList: [], // 广告位
      pageEnterTime: null // 页面进入时间
    }
  },
  head () {
    return {
      title: this.$t('19804'),
      meta: [{ name: 'Description', content: this.$t('19805') }]
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  watch: {
    // 监听页面滚动
    '$store.state.scrollDistance' (newV) {
      this.isInViewPort(newV)
    },
    // 监听菜单导航栏（移动端）选中项的变化
    wapSelect (newV) {
      const idx = subtract(newV, 1)
      this.$refs?.mTab?.handleNavClick(this.wapMenuList[idx], idx, false)
    }
  },
  mounted () {
    this.bannerHeight = document.getElementById('banner-ref')?.offsetHeight || 0
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
  },
  beforeDestroy () {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    this.trackPageTime()
  },

  methods: {
    // 判断元素是否在可视区内 -> offsetTop < scrollTop + clientHeight && offsetTop > scrollTop - offsetHeight
    isInViewPort (value = 0) {
      if (this.isMobile) this.wapSelect = (menuLight(this.wapMenuList, value, 100) || this.wapSelect) // 移动端时，根据滚动距离自动判断高亮某一个菜单项
      for (let i = 0; i < this.componentList?.length; i++) {
        const item = this.componentList[i]
        if (item.isShow) continue // 页面元素已加载，不执行后续操作
        const [rollDistance, modularDom] = [(document?.documentElement?.scrollTop || document?.body?.scrollTop || 0), document.getElementById(item.dom)]
        const [modularTop, modularHeight] = [modularDom?.offsetTop, modularDom?.offsetHeight]
        item.isShow = (modularTop < add(rollDistance, window?.screen?.height) && modularTop > subtract(rollDistance, modularHeight))
      }
      this.isFixed = (value >= this.bannerHeight)
      // this.componentList?.forEach((item) => {
      //   item.isShow = item.isShow || this.isVisibleFn(document.getElementById(item.id))
      // })
      // this.componentList.splice(this.componentList?.length)
    },
    // 判断元素是否在可视区内
    isVisibleFn (dom = {}, headHeight = 132) {
      const offset = dom?.getBoundingClientRect()
      const [offsetTop, offsetBottom] = [offset?.top, offset?.bottom]
      return (offsetTop <= window?.innerHeight && subtract(offsetBottom, headHeight) >= 0)
    },
    // 滚动至页面指定位置
    scrollToModules ({ dom = '' }) {
      toSpecifyLocation(dom)
    },
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_Home_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    }
  }
}
